
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
  
import { mdiArrowDown, mdiArrowRight, mdiEmailOutline } from '@mdi/js';

import BackgroundComponent from '@/components/design-system/style/BackgroundComponent.vue';
import BlobComponent from '@/components/design-system/style/BlobComponent.vue';
import BodyText from '../../components/design-system/typography/BodyText.vue';
import ButtonComponent from '../../components/design-system/input/ButtonComponent.vue';
import CardComponent from '@/components/design-system/containers/CardComponent.vue';
import DonateBlock from '@/components/DonateBlock.vue';
import FooterMultiWord from '@/components/FooterMultiWord.vue';
import FormComponent from '@/components/design-system/input/FormComponent.vue';
import HeadlineText from '@/components/design-system/typography/HeadlineText.vue';
import IconComponent from '@/components/design-system/icons/IconComponent.vue';
import InfoBubble from '@/components/InfoBubble.vue';
import MasonryGrid from '@/components/design-system/layout/MasonryGrid.vue';
import NavigationBar from '@/components/design-system/navigation/NavigationBar.vue';
import StackComponent from '../../components/design-system/layout/StackComponent.vue';
import StaticContentLayout from '@/components/layouts/StaticContentLayout.vue';
import StickyHeaderLayout from '@/components/layouts/StickyHeaderLayout.vue';
import TextInputComponent from '@/components/design-system/input/TextInputComponent.vue';
import TitleText from '@/components/design-system/typography/TitleText.vue';

</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body">
<p>Tato stránka slouží jako archiv starších volebních kalkulaček. Aktuální kalkulačku vždy najdete na hlavní adrese <a href="https://www.volebnikalkulacka.cz">www.volebnikalkulacka.cz</a>.</p>
<p>Archivní kalkulačky jsou stále plně funkční a můžete si je kdykoliv vyzkoušet a podívat se, s jakými kandidáty nebo stranami byste se shodli v minulých volbách.</p>
<p><strong>Archiv 2022–2023:</strong> Kalkulačky z prezidentských, komunálních a senátních voleb najdete na <a href="https://archiv.volebnikalkulacka.cz">archiv.volebnikalkulacka.cz</a>.</p>
<p><strong>Co se stalo s profily?</strong> Funkci profilů jsme zrušili. Pokud jste měli vytvořený profil, automaticky jsme vás přihlásili k odběru našeho newsletteru, abyste zůstali v kontaktu a informovali se o nových kalkulačkách.</p>
<p>Kromě českých kalkulaček tvoříme kalkulačky i <a href="https://volebnakalkulacka.sk">na Slovensku</a>, <a href="https://wahlrechner.at">v Rakousku</a> a <a href="https://voksmonitor.hu">Maďarsku</a>.</p>
<p>Chcete nám pomoct? Pokud byste chtěli pomoct jako dobrovolník, ozvěte se nám na <a href="mailto:info@kohovolit.eu">info@kohovolit.eu</a> nebo budeme rádi, když nás <a href="https://www.darujme.cz/darovat/1200653">podpoříte</a> finančně.</p>
<br>
<masonry-grid style="align-self: stretch">
   <card-component corner="top-right" padding="medium" border="" shadow="">
   <div class="card-content">
      <div class="card-content-text">
         <title-text tag="h3" size="medium">Prezidentské volby 2023</title-text>
         <body-text size="medium">Volby prezidenta České republiky 2023, 42 otázek, cca 10
         minut</body-text>
      </div>
      <button-component kind="filled" color="primary" tag="a" href="https://archiv.volebnikalkulacka.cz/volby/prezidentske-2023/pro-kazdeho/navod">
         Spustit kalkulačku pro 1. kolo
         <template #iconafter="">
         <icon-component :icon="mdiArrowRight" />
         </template>
      </button-component>
   </div>
   </card-component>
   <card-component corner="top-right" padding="medium" border="" shadow="">
   <div class="card-content">
      <div class="card-content-text">
         <title-text tag="h3" size="medium">Prezidentské volby 2023: 2. kolo</title-text>
         <body-text size="medium">Volební kalkulačka pro 2. kolo, 20 otázek, cca 5
         minut</body-text>
      </div>
      <button-component kind="outlined" color="primary" tag="a" href="https://archiv.volebnikalkulacka.cz/volby/prezidentske-2023/pro-kazdeho-2-kolo/navod">
         Spustit kalkulačku
         <template #iconafter="">
         <icon-component :icon="mdiArrowRight" />
         </template>
      </button-component>
   </div>
   </card-component>
   <card-component corner="top-right" padding="medium" border="" shadow="">
   <div class="card-content">
      <div class="card-content-text">
         <title-text tag="h3" size="medium">Prezidentské volby 2023: pro nadšence</title-text>
         <body-text size="medium">Všech 98 otázek, které jsme položili prezidentským
         kandidátům.
         </body-text>
      </div>
      <button-component kind="outlined" color="primary" tag="a" href="https://archiv.volebnikalkulacka.cz/volby/prezidentske-2023/pro-nadsence/navod">
         Spustit kalkulačku
         <template #iconafter="">
         <icon-component :icon="mdiArrowRight" />
         </template>
      </button-component>
   </div>
   </card-component>
   <card-component corner="top-right" padding="medium" border="" shadow="">
   <div class="card-content">
      <div class="card-content-text">
         <title-text tag="h3" size="medium">Prezidentské volby 2023: pro mladé</title-text>
         <body-text size="medium">Otázky, které rezonují mladou generací.<br>
         Ve spolupráci s projektem
         <a href="https://www.nazorypolitiku.cz" target="_blank">
            NázoryPolitiků.cz </a>.</body-text>
      </div>
      <button-component kind="outlined" color="primary" tag="a" href="https://archiv.volebnikalkulacka.cz/volby/prezidentske-2023/pro-mlade/navod">
         Spustit kalkulačku
         <template #iconafter="">
         <icon-component :icon="mdiArrowRight" />
         </template>
      </button-component>
   </div>
   </card-component>
   <card-component corner="top-right" padding="medium" border="" shadow="">
   <div class="card-content">
      <div class="card-content-text">
         <title-text tag="h3" size="medium">Komunální volby 2022</title-text>
         <body-text size="medium">K dispozici jsou kalkulačky pro vybraná města.</body-text>
         <div class="divider"></div>
         <body-text size="small">Komunální kalkulačku vyplnilo přes 100 tisíc lidí.</body-text>
      </div>
      <button-component kind="filled" color="primary" href="https://archiv.volebnikalkulacka.cz/volby/komunalni-2022/vyber">Spustit kalkulačku</button-component>
   </div>
   </card-component>
   <card-component corner="top-left" padding="medium" border="" shadow="">
   <div class="card-content">
      <div class="card-content-text">
         <title-text tag="h3" size="medium">Senátní volby 2022</title-text>
         <body-text size="medium">Pro jednotlivé volební obvody.</body-text>
         <body-text size="medium"><a href="https://2022.programydovoleb.cz/senatni-volby#kde-se-letos-voli">Více o senátních obvodech</a></body-text>
      </div>
      <div class="divider"></div>
      <body-text size="small">Senátní kalkulačku vyplnilo přes 25 tisíc lidí.</body-text>
      <button-component color="primary" kind="filled" href="https://archiv.volebnikalkulacka.cz/volby/senatni-2022/vyber">Spustit kalkulačku</button-component>
   </div>
   </card-component>
</masonry-grid></div>
</template>
